enum keys {
  alertModalKey = "alertModalKey",
  adminDataKey = "adminDataKey",
  loadingKey = "loadingKey",
  pathKey = "pathKey",
}

export default keys;
